import { render, staticRenderFns } from "./ClassifiedQuickSearchPlotFacets.vue?vue&type=template&id=2ddfc7f8&"
import script from "./ClassifiedQuickSearchPlotFacets.vue?vue&type=script&lang=ts&"
export * from "./ClassifiedQuickSearchPlotFacets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports